import React, { useEffect, useState } from 'react';
import { Input, Space, Modal, Button, Form, message } from 'antd';
import { validateUser, updateUserPassword } from '../Controller/Management/UserProf_Ctrl';

export default function Profile(prop) {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        myForm.resetFields(["password"])
        setIsModalVisible(false);
    };


    const [myForm] = Form.useForm()
    const PasswordForm = () => {
        const [allowEdit, setAllowEdit] = useState(false)
        const [disableBtn, setDisableBtn] = useState(true)
        const formFin = async (data) => {
            if (allowEdit) {
                delete data.password2
            }
            let result = !allowEdit ? await validateUser(data) :
                await updateUserPassword(data)
            if (result && result.status) {
                if (allowEdit) {
                    //is edit user
                    if (result.status === "ok") {
                        message.success("Password successfully changed")
                        handleCancel()
                    }
                    else {
                        message.error("Can't change password...")
                    }
                }
                else {
                    //is validate user
                    if (result.data) {
                        setAllowEdit(true)
                    }
                    else {
                        myForm.resetFields(["password"])
                        message.warning("it's not your password!")
                    }

                }
            }
            else {
                message.error("We encountered error")
                handleCancel()
            }
        }

        useEffect(() => {
            myForm.setFieldsValue({ "userid": prop.userid })
        }, [])

        return (
            <>
                <Form
                    onFinish={formFin}
                    form={myForm}
                >
                    <Form.Item
                        noStyle
                        name="userid"
                    >

                    </Form.Item>

                    {
                        allowEdit ?
                            <>
                                <Form.Item
                                    rules={[
                                        { required: true, message: "Please enter a new password!" }
                                    ]}
                                    label="newPassword" name="password">
                                    <Input.Password
                                        onInput={(val) => { if (val.target.value === myForm.getFieldValue("password2")) { setDisableBtn(false) } else { setDisableBtn(true) } }}
                                        maxLength="15"
                                        placeholder="New password"


                                    />
                                </Form.Item>
                                <Form.Item label="Confirm Password (MUST BE SAME)"
                                    name="password2"
                                    rules={[
                                        { required: true, message: "Please confirm your password!" },
                                        // { pattern: new RegExp(myForm.getFieldValue("password"), "i"), message: "The passwords were not matched!" }
                                    ]}
                                >
                                    <Input.Password
                                        onInput={(val) => { if (val.target.value === myForm.getFieldValue("password")) { setDisableBtn(false) } else { setDisableBtn(true) } }}
                                        placeholder="Confirm new password"
                                        maxLength="15"

                                    />
                                </Form.Item>
                            </>
                            :
                            <Form.Item
                                name="pass"
                                rules={[
                                    { required: true, message: "Please enter current password!" }
                                ]}
                            >
                                <Input

                                    type="password"
                                    placeholder="Current password"
                                    maxLength="15"
                                // onKeyUpCapture={e => setOPassword(e.target.value)}
                                />
                            </Form.Item>
                    }
                    <Form.Item>
                        <Button type="primary" htmlType="submit" disabled={allowEdit && disableBtn}>{allowEdit ? "Change password" : "Prove myself"}</Button>
                    </Form.Item>

                </Form>


            </>
        )

    }
    return (
        <>
            <a onClick={showModal}>
                Change Password
            </a>
            <Modal
                title="Change Password"
                visible={isModalVisible}
                maskClosable={true}
                closable={true}
                destroyOnClose
                onCancel={() => { setIsModalVisible(false); myForm.resetFields() }}
                footer={null}
            >
                <Space direction="vertical">
                    <PasswordForm />
                </Space>
            </Modal>
        </>
    );
};

